import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/onboarding/lockup.svg'


const _withScopeId = n => (_pushScopeId("data-v-5faa66bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-container about-main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "lockup",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "about-head" }
const _hoisted_4 = { class: "about-body" }
const _hoisted_5 = { class: "about-body" }

import { computed, onMounted, onUnmounted, watch } from "vue";
import { data } from "@/data/dataHelper";
import SwipeGesture from '@/components/helpers/SwipeGesture.vue';
import IntroCornerSVG from '@/components/svgs/IntroCornerSVG.vue';
import useStore, { PageTransitions } from '../store/useStore'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroView',
  setup(__props) {

const store = useStore()

const languageUtilities = computed(() => {
  return data.translationsByLanguage(store.language);
})

const gotToBabySelect = () => {
  store.goToMenu()
  store.setPageTransitionName(PageTransitions.SLIDE_UP)
}

const onUpSwipe = () => {
  store.setPageTransitionName(PageTransitions.SLIDE_UP)
  store.goToMenu()
}

const onDownSwipe = () => {
  store.setPageTransitionName(PageTransitions.SLIDE_DOWN)
  // store.goToHome()
}
onMounted(() => {
  store.legendState = 0
  if (store.isElectron) {
    store.showLegend = true
    clearInterval(store.legendTimeout)
    store.legendTimeout = setInterval(() => {
      if (store.legendState !== 0) store.showLegend = !store.showLegend
    }, 7000)
  }

})

onUnmounted(() => {
  store.showLegend = true

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwipeGesture, {
    onUp: onUpSwipe,
    onDown: onDownSwipe
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["about", { 'about-desktop': !_unref(store).isElectron }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(languageUtilities).onboardingText.page1Title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(languageUtilities).onboardingText.page1Body), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(languageUtilities).onboardingText.page2Body), 1)
          ]),
          _createElementVNode("button", {
            class: "primary no-fade-in onboarding-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (gotToBabySelect()))
          }, _toDisplayString(_unref(languageUtilities).startExploringText), 1)
        ]),
        _createVNode(IntroCornerSVG)
      ], 2)
    ]),
    _: 1
  }))
}
}

})